/*
 * Public API Surface of ds-lib-main-menu
 */

/** Components */
export * from './lib/ds-lib-main-menu.component';

/** Modules */
export * from './lib/ds-lib-main-menu.module';

/**
 * Export models
 */
export * from './lib/models/ds-lib-main-menu-link.model';
export * from './lib/models/ds-lib-main-menu-list-item.model';
export * from './lib/models/ds-lib-main-menu-tab.model';
export { DsMainMenuLogos } from './lib/models/ds-main-menu-logos.model';

/**
 * Export interfaces
 */
export * from './lib/interfaces/ds-lib-main-menu-link.interface';
export * from './lib/interfaces/ds-lib-main-menu-list-item.interface';
export * from './lib/interfaces/ds-lib-main-menu-user.interface';
export * from './lib/interfaces/ds-lib-main-menu-section.interface';
export * from './lib/interfaces/ds-lib-main-menu-tab.interface';
export { DsMainMenuLogsInterface } from './lib/interfaces/ds-main-menu-logs.interface';

/** Router link args */
export * from './lib/interfaces/ds-lib-main-menu-router-link-args.interface';
